import { render, staticRenderFns } from "./dueForDrying.vue?vue&type=template&id=1252472a&scoped=true&"
import script from "./dueForDrying.vue?vue&type=script&lang=js&"
export * from "./dueForDrying.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1252472a",
  null
  
)

export default component.exports